import { render, staticRenderFns } from "./tjgl.vue?vue&type=template&id=17598763&scoped=true"
import script from "./tjgl.vue?vue&type=script&lang=js"
export * from "./tjgl.vue?vue&type=script&lang=js"
import style0 from "./tjgl.vue?vue&type=style&index=0&id=17598763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17598763",
  null
  
)

export default component.exports